import React, { ChangeEvent } from "react";
import { Updater, useImmer } from "use-immer";

import { IgTextField, IgTypography } from "@intelligems/ig-theme";
import { Switch } from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import { ISitewideDashboardFilters } from "@src/store/types/sitewideDashboardFilters";

import { IExperienceDashboardFilters } from "../../../store/types/dashboardFilters";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: theme.igPrimitives.gray[50],
      "& + .MuiSwitch-track": {
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));

interface ZScoreFilterProps {
  isZScoreEnabled: boolean;
  maxZScore: string | number | null;
  setDialogFilters: {
    bivarianceHack(arg: any): void;
  }["bivarianceHack"];
  onBooleanFilterChange: (
    checked: boolean,
    filterKey: "isZScoreEnabled"
  ) => void;
}

export const ZScoreFilter = ({
  isZScoreEnabled,
  maxZScore,
  setDialogFilters,
  onBooleanFilterChange,
}: ZScoreFilterProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onBooleanFilterChange(event.target.checked, "isZScoreEnabled");
  };
  const [maxZScoreError, setMaxZScoreError] = useImmer<boolean>(false);
  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      marginBottom="10px"
      wrap="nowrap"
    >
      <Grid>
        <AntSwitch
          checked={isZScoreEnabled}
          onChange={handleChange}
          sx={{ marginRight: "15px" }}
        />
      </Grid>
      <Grid marginRight={"15px"}>
        <IgTypography>Max Z-Score</IgTypography>
      </Grid>
      <Grid marginRight={"10px"}>
        <IgTextField
          // sx={{ width: "70px", height: "40px" }}
          variant="outlined"
          value={!isZScoreEnabled ? "9999" : maxZScore}
          slotProps={{
            htmlInput: {
              min: 0,
              inputMode: "numeric",
              pattern: "^[0-9][\\.\\d]*(,\\d+)?$",
            },
          }}
          disabled={!isZScoreEnabled}
          type="text"
          onChange={(e) => {
            const value = e.target.value;
            if (e.target.validity.valid) {
              setDialogFilters((draft) => {
                draft.maxZScore = value;
                return draft;
              });
              if (value !== "") {
                setMaxZScoreError(false);
              } else {
                setMaxZScoreError(true);
              }
            } else {
              setMaxZScoreError(true);
            }
          }}
          error={maxZScoreError}
        />
      </Grid>
      <Grid sx={{ paddingLeft: "0px" }}>
        {maxZScoreError && (
          <IgTypography color="error" sx={{ paddingLeft: "5px" }}>
            Max Z-Score must be a number
          </IgTypography>
        )}
      </Grid>
    </Grid>
  );
};
